import { DestinyRoute, IOnGoingTrip, ITripStopItem, OriginRoute } from "@types";
import { AuthContext, TFollowers } from "src/providers/AuthProvider";
import { useContext, useState } from "react";
import ConfirmDialog from "../Dialogs/Confirm";
import { PublicHeader } from "./components/PublicHeader";
import { PrivateHeader } from "./components/PrivateHeader";
import { PublicInfo } from "./components/PublicInfo";
import { TripDetails } from "./components/TripDetails";
import { ShareSection } from "./components/ShareSection";
import { StopsSection } from "./components/StopsSection";

interface Props {
  detail?: IOnGoingTrip | null;
  origin?: OriginRoute;
  destiny?: DestinyRoute;
  stops?: ITripStopItem[];
  followers?: TFollowers;
  statusTripNow?: string;
  statusRouteNow?: string;
  progressNow?: string;
  handleShare?: (id: string) => void;
  type?: 'PUBLIC' | 'DEFAULT',
  currencyAddress?: string;
  handleCopy?: () => void;
  isPolyline?: boolean;
  currencyLocation?: string;
  onClickCheckpoint?: (id: string) => void;
  children?: React.ReactNode;
  onFinishTrip?: () => void;
}


const SidebarDetail = ({
  detail,
  destiny,
  origin,
  stops,
  followers,
  statusTripNow,
  statusRouteNow,
  progressNow,
  handleShare,
  handleCopy,
  type = 'DEFAULT',
  currencyAddress,
  currencyLocation,
  onClickCheckpoint,
  children,
  isPolyline,
  onFinishTrip,
}: Props) => {

  const { getDetailUser } = useContext(AuthContext);
  const user = getDetailUser?.(detail?.profileId);
  const isPublic = type === "PUBLIC";
  const isPrivate = type !== "PUBLIC";
  const [showConfirmFinish, setShowConfirmFinish] = useState(false);

  return (
    <div>
      {isPrivate && <PrivateHeader detail={detail} user={user} />}
      {isPublic && <PublicHeader detail={detail} />}
      {isPublic && <PublicInfo detail={detail} currencyAddress={currencyAddress} />}

      <TripDetails 
        detail={detail} 
        statusTripNow={statusTripNow} 
        statusRouteNow={statusRouteNow} 
        progressNow={progressNow}
        type={type}
      />

      {isPrivate && (
        <ShareSection 
          detail={detail} 
          currencyLocation={currencyLocation} 
          handleShare={handleShare} 
        />
      )}

      {isPrivate && (
        <StopsSection 
          origin={origin} 
          destiny={destiny} 
          stops={stops} 
          onClickCheckpoint={onClickCheckpoint} 
        />
      )}

      {isPublic && (
        <div className="display-flex width-100pct padding-y-15 padding-x-15">
          <button type="button" className="btn btn-default width-100pct" onClick={handleCopy}>
            Copiar link da viagem
          </button>
        </div>
      )}

      {isPrivate && onFinishTrip && detail?.tripStatusNow !== 'NOTSTARTED' && (
        <div className="padding-x-15 padding-y-15 text-center">
          {detail?.hec48hrs && (detail?.tripStatusNow === 'STARTED' || detail?.tripStatusNow === 'PAUSED') && (
            <p className="text-color-danger text-size-14 margin-bottom-10 text-bold">
              Viagem com HEC acima de 48 horas.
            </p>
          )}
          <button type="button" className={"btn btn-danger text-white text-bold width-100pct"} onClick={() => setShowConfirmFinish(true)}>
            Finalizar viagem
          </button>
        </div>
      )}

      <ConfirmDialog
        show={showConfirmFinish}
        title="Finalizar Viagem"
        content="Tem certeza que deseja finalizar esta viagem?"
        onClickConfirm={() => {
          setShowConfirmFinish(false);
          onFinishTrip?.();
        }}
        onClickCancel={() => setShowConfirmFinish(false)}
        confirmButtonText="Sim, finalizar"
        cancelButtonText="Cancelar"
      />
    </div>
  );
};

export default SidebarDetail;


